import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import SelectProduct from '../select-product/component';
import ComposeReport from '../compose-report/component';
import usePrevious from '../../services/usePrevious';

// import ToolResult from '../tool-result/container';
import Style from './style';

const Tool = ({
    selectproduct,
    content,
    handleRefresh,
}) => {
    if (!_.isEqual(content, usePrevious(content))) {
        handleRefresh();
    }
    return (
        <Style>
            <SelectProduct />
            <ComposeReport />

        </Style>

    );

};

Tool.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectproduct: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    content: PropTypes.object,
    handleRefresh: PropTypes.func,
};

Tool.defaultProps = {
    selectproduct: {},
    content: {},
    handleRefresh: () => {},
};
export default Tool;
